import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function WhatYouGet() {
  const deliverables = [{
    title: 'The 18-Minute "Core Temp" Reset',
    desc: 'The exact physical routine to kill a hot flash in 60 seconds.'
  }, {
    title: 'The Estrogen-Cortisol Handshake',
    desc: 'Why you get a "second wind" at 10 PM and how to stop it.'
  }, {
    title: 'The Bedroom Audit',
    desc: '5 invisible triggers in your room that are acting like heaters.'
  }, {
    title: 'The 3:15 AM Emergency Flowchart',
    desc: 'Exactly what to do (and what NEVER to do) the moment your eyes open.'
  }, {
    title: 'The "Stabilizer Snack"',
    desc: 'One specific 30-second evening snack that prevents the midnight adrenaline dump.'
  }];
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 bg-night-800/30" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <FadeIn data-id="element-166">
          <h3 className="font-serif text-3xl md:text-4xl text-white mb-12 text-center" data-id="element-167">
            What You Get Inside The Protocol
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-168">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === deliverables.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''} data-id="element-169">
              <div className="bg-night-800 p-6 rounded-xl border border-night-700 h-full hover:border-amber-500/30 transition-colors" data-id="element-170">
                <div className="flex items-start gap-4" data-id="element-171">
                  <CheckCircle2 className="w-6 h-6 text-amber-500 shrink-0 mt-1" data-id="element-172" />
                  <div data-id="element-173">
                    <h4 className="text-white font-bold text-lg mb-2" data-id="element-174">
                      {item.title}
                    </h4>
                    <p className="text-cream/70 leading-relaxed" data-id="element-175">{item.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn className="flex justify-center" data-id="element-176">
          <Button onClick={scrollToCTA} data-id="element-177">Get Instant Access Now</Button>
        </FadeIn>
      </div>
    </section>;
}